module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/COM类：集上下料+贴Holder镜头+烘烤一体.541ebd2f.jpg";